import { trackEvent as t } from '../track';
import { SearchProps } from './propertyTypes';

export const search = {
  clear: () => t('[Search] Clear search criteria'),
  keywordSearch: (props: SearchProps) => t('[Search] Initiate keyword search', props),
  viewResults: (props: SearchProps) => t('[Search] View results', props),
};